/**
 * Ürün kartı sepete ekleme — tek seferlik yüklenir.
 *
 * Önceden bu kod her kartın içine <script> olarak gömülüydü; 24 ürünlük bir
 * koleksiyonda aynı JS+CSS ~194 KB gereksiz HTML üretiyordu.
 *
 * Olay delegasyonu kullanıyoruz: filtreleme (facets) sonrası DOM yenilendiğinde
 * kartlar yeniden bağlanmaya gerek kalmadan çalışmaya devam eder.
 */
(function () {
  'use strict';

  function sepetiTazele() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function cekmeceyiAc() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;

    fetch(window.Shopify.routes.root + '?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var fresh = tmp.querySelector('.drawer__inner');
          var current = drawer.querySelector('.drawer__inner');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        drawer.classList.remove('is-empty');
        drawer.open();
      })
      .catch(function () {});
  }

  function sepeteEkle(btn, varyantId, basariMetni, eskiMetin) {
    btn.classList.add('is-loading');
    btn.textContent = '···';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: varyantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add basarisiz');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = basariMetni;
        sepetiTazele();
        cekmeceyiAc();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = eskiMetin;
        }, 1800);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = eskiMetin;
      });
  }

  // Tek dinleyici — tüm kartlar için, şimdiki ve gelecekteki
  document.addEventListener('click', function (e) {
    // 1) Beden çipi: TIKLANAN BEDENİN kendi varyantını ekler
    var beden = e.target.closest('.cv-beden');
    if (beden) {
      e.preventDefault();
      e.stopPropagation();
      if (beden.disabled || beden.classList.contains('is-loading')) return;
      var bid = beden.dataset.variantId;
      if (!bid) return;
      sepeteEkle(beden, bid, '✓', beden.textContent);
      return;
    }

    // 2) Bedensiz ürünlerde klasik "+" hızlı ekle
    var arti = e.target.closest('.cv-add');
    if (arti) {
      e.preventDefault();
      e.stopPropagation();
      if (arti.classList.contains('is-loading')) return;
      var aid = arti.dataset.variantId;
      if (!aid) return;
      sepeteEkle(arti, aid, '✓', '+');
    }
  });
})();
